export const baseUrl = process.env.REACT_APP_PUBLIC_BASEURL
console.log("🚀 ~ process.env.REACT_APP_PUBLIC_BASEURL:", process.env.REACT_APP_PUBLIC_BASEURL)